import { SectionBlock } from '../../../../blocks/SectionBlock';
import { Spinner } from '../../../../components/Spinner';
import { TTeamWiseEmployeeData } from '../../../../types/analyticsTypes';
import { useTeamStats } from '../../hooks/useTeamStats';
import { LineChart } from '../OverallStats/LineChart';

import { StatsCards } from './StatsCards';
import { TeamMemberStatsTable } from './TeamMemberStatsTable';

type TeamOption = {
  id: string;
  label: string;
  value: string;
};

export interface TeamWiseStatsProps {
  data: {
    currentPeriod: TTeamWiseEmployeeData;
    previousPeriod: TTeamWiseEmployeeData;
    todayOooMap: { [key: string]: boolean };
  };
  selectedTeam: TeamOption | null;
  setSelectedTeam: (team: TeamOption | null) => void;
}

export function TeamWiseStats({
  data,
  selectedTeam,
  setSelectedTeam,
}: TeamWiseStatsProps): JSX.Element {
  const { teamStats, teamMembers, isLoading, error } = useTeamStats({
    data,
    selectedTeam,
  });

  if (error) {
    return <div className="text-red-500">{error}</div>;
  }

  return (
    <SectionBlock skipContentContainer>
      <div className="flex flex-col gap-4 ">
        {isLoading && <Spinner />}
        {!isLoading && teamStats && (
          <>
            <StatsCards stats={teamStats} />
            <TeamMemberStatsTable teamMembers={teamMembers} />
            <LineChart
              selectedTeam={selectedTeam}
              setSelectedTeam={setSelectedTeam}
            />
          </>
        )}
      </div>
    </SectionBlock>
  );
}
